import { render, staticRenderFns } from "./column-head.vue?vue&type=template&id=16ad01d6"
import script from "./column-head.vue?vue&type=script&lang=js"
export * from "./column-head.vue?vue&type=script&lang=js"
import style0 from "./column-head.vue?vue&type=style&index=0&id=16ad01d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports